import React from 'react';
import type { DataSourceItem } from '../../../hooks/useDashboardTopBar';
import { formatDataSourceTimestamp } from '../../../helpers/dateHelper';

interface DataSourceTimestampProps {
  dataSource: DataSourceItem[];
  lastImportBySource: Record<string, string>;
}

export const DataSourceTimestamp: React.FC<DataSourceTimestampProps> = ({
  dataSource,
  lastImportBySource,
}) => {
  if (!dataSource || dataSource.length === 0) {
    return null;
  }

  return (
    <div className="data-source-timestamp-container">
      {dataSource.map((item, index) => {
        const timestamp = lastImportBySource[item.key];
        if (!timestamp) {
          return null;
        }
        return (
          <div key={index} className="data-source-item">
            <span className="data-source-title">{item.title}</span>
            <span className="data-source-timestamp">
              {formatDataSourceTimestamp(timestamp)}
            </span>
          </div>
        );
      })}
    </div>
  );
};
